import LoadingIndicator from 'gcs-common/components/LoadingIndicator/LoadingIndicator';
import { getSelectedTenant, getSelectedTenantLoading } from 'gcs-common/slices/administration/tenants/tenantsSelectors';
import { tenantSelectionReset } from 'gcs-common/slices/administration/tenants/tenantsSlice';
import { fetchTenantDetails } from 'gcs-common/slices/administration/tenants/tenantsThunks';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import backIcon from '../../../../img/back.svg';
import styles from './styles.module.scss';

const TenantDetail = () => {
  const { id: tenantId } = useParams();

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const selectedTenant = useSelector(getSelectedTenant);
  const selectedTenantLoading = useSelector(getSelectedTenantLoading);

  useEffect(() => {
    (async () => {
      await dispatch(fetchTenantDetails({ tenantId }));
    })();
    return () => dispatch(tenantSelectionReset());
  }, [dispatch, tenantId]);

  return (
    <div>
      <div className={styles.headerRow}>
        <div className={styles.row}>
          <button className={styles.backButton} type="button" onClick={() => navigate(-1)}>
            <img src={backIcon} alt="back-icon" />
          </button>
          <span className={styles.headerText}>{selectedTenant?.friendlyName}</span>
        </div>
        {selectedTenantLoading && <LoadingIndicator padding="0px" />}
      </div>
    </div>
  );
};
export default TenantDetail;
